export default __webpack_public_path__ + "static/media/tedaHai.16d0efd3.png";